.container {
    padding: 16px;
    max-width: 675px;
}

.inner-container {
    margin-top: 32px;
}
